/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework from '@greenville/framework';
import {
  getPromptEditorMode,
  PROMPT_EDITOR_MODE_CATALOGUE,
  PROMPT_EDITOR_MODE_INLINE
} from '../../../common/prompt/promptManagementFlag';

export { getPromptEditorMode, PROMPT_EDITOR_MODE_CATALOGUE, PROMPT_EDITOR_MODE_INLINE };

/**
 * Prompt editor mode for Studio's currently selected tenant.
 * @returns {'catalogue'|'inline'}
 */
export function getCurrentPromptEditorMode() {
  const tenantState = Framework.getStoreRegistry().getStore('tenantState');
  return getPromptEditorMode(tenantState?.selectedTenant);
}

export function isCataloguePromptEditorMode(mode = getCurrentPromptEditorMode()) {
  return mode === PROMPT_EDITOR_MODE_CATALOGUE;
}

/**
 * True when any React Flow editor node (or API-shaped node) carries catalogue prompt refs.
 * @param {Array} nodes
 * @returns {boolean}
 */
export function graphNodesHavePromptRefs(nodes = []) {
  return (nodes || []).some((node) => {
    const config = node?.data?.config || node?.data?.agentConfig || {};
    return Boolean(config.promptRef && config.promptVersionRef);
  });
}
